import { useState, useEffect, type JSX } from "react"
import { IconButton } from "@mui/material"
import { Fullscreen, FullscreenExit } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import type { IDockviewHeaderActionsProps } from "dockview"

type RightControlsProps = IDockviewHeaderActionsProps & {
  persistLayout?: () => void
}

export default function RightControls(props: RightControlsProps): JSX.Element {
  const [maximized, setMaximized] = useState(props.containerApi.hasMaximizedGroup())

  useEffect(() => {
    const disposable = props.containerApi.onDidMaximizedGroupChange(() => {
      setMaximized(props.api.isMaximized())
    })

    return () => {
      disposable.dispose()
    }
  }, [props.containerApi, props.api])

  const toggleMaximized = () => {
    if (maximized) {
      props.api.exitMaximized()
    } else {
      props.api.maximize()
    }
    props.persistLayout?.()
  }

  return (
    <OPTooltip title={maximized ? "Restore" : "Maximize"}>
      <span>
        <IconButton onClick={toggleMaximized}>
          {maximized ? <FullscreenExit /> : <Fullscreen />}
        </IconButton>
      </span>
    </OPTooltip>
  )
}
